import { Grid, IconButton } from "@material-ui/core"
import { UtilsStyles } from "./utilsStyle";
import AutorenewIcon from '@material-ui/icons/Autorenew';
// import SearchBar from "material-ui-search-bar";
export const SearchBar = ({ reloadTable, filter, setFilter }) => {

    const classes = UtilsStyles();

    return (
        <>

            {/*<Grid item xs={1} sm={1} md={1} style={{ textAlign: "right", paddingTop: 17, paddingRight: 0 }}>
                    <IconButton
                        size="large"
                        color="Primary"
                        onClick={(e) => { reloadTable() }}
                    >
                        <RotateLeftIcon style={{ fontSize: 30 }} />
                    </IconButton>
    </Grid>*/}
            <Grid container alignItems="center" justifyContent="center" spacing={1} style={{ width: '100%', marginLeft:'9px' }}>
                <Grid item xs={11} style={{ paddingRight: '8px' }}>
                    <input
                    type="search"
                        placeholder='Número de Celular o Documento'
                        variant="outlined"
                        inputProps={{ className: classes.search }}
                       
                        value={filter}
                        onChange={((e) => {
                            setFilter(e.target.value);
                        })}
                    />

                </Grid>
                <Grid item xs={1} style={{ paddingLeft: '8px' }}>
                    <IconButton
                        size="large"
                        color="Primary"
                        onClick={(e) => {
                            reloadTable();
                            setFilter("")
                        }}
                    >
                        <AutorenewIcon style={{ fontSize: 30 }} />
                    </IconButton>
                </Grid>
            </Grid>
        </>
    )
}